namespace EmbeddingProcessStatesEnums {
  /**
   * The status of an embedding process of a model.
   */
  export enum Status {
    PENDING = "pending",
    IN_PROGRESS = "in_progress",
    COMPLETED = "completed",
  }
}

export default EmbeddingProcessStatesEnums;
